export const RG_DIGITAL_ENVIO_SMS: string = 'RG_DIGITAL_ENVIO_SMS';
export const HABILITA_CIN: string = 'HABILITA_CIN';
export const HABILITAR_DBCIN: string = 'HABILITAR_DBCIN';
export const HABILITA_MULTIFILIACAO: string = 'HABILITA_MULTIFILIACAO';
export const ANEXAR_DOC_DA_DIVERGENCIA_CPF: string =
	'ANEXAR_DOC_DA_DIVERGENCIA_CPF';
export const HABILITA_CADASTRO_CIPTEA: string = 'HABILITA_CADASTRO_CIPTEA';
